<script>
  import IconButton from '@smui/icon-button';
  import { navigate } from 'svelte-routing';
  import { role } from '../../stores/core-store';

  export let disabled = false;
</script>

{#if $role === 'InstitutionAdmin'}
  <IconButton
    id="add-department-button"
    title="Add Department"
    class="material-icons gigxr-icon-button add-department-button"
    on:click={() => navigate('/departments/create')}
    {disabled}
  >
    add_box
  </IconButton>
{/if}

<style>
  :global(.add-department-button:disabled) {
    opacity: 0.38;
  }
</style>
